import { render, staticRenderFns } from "./downPayment.vue?vue&type=template&id=05a71479&scoped=true"
import script from "./downPayment.vue?vue&type=script&lang=js"
export * from "./downPayment.vue?vue&type=script&lang=js"
import style0 from "./downPayment.vue?vue&type=style&index=0&id=05a71479&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a71479",
  null
  
)

export default component.exports